import React, { useState } from "react";
import { Trash2, Send } from "lucide-react";
import {urlFor} from "../sanityClient";
import {Link} from "react-router-dom";

const Wishlist = () => {
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [role, setRole] = useState(""); // Vai trò khách hàng
    const [note, setNote] = useState(""); // Ghi chú
    const [wishlist, setWishlist] = useState(() => {
        const savedWishlist = localStorage.getItem("wishlist");
        return savedWishlist ? JSON.parse(savedWishlist) : [];
    });

    // Xóa sản phẩm khỏi wishlist
    const removeFromWishlist = (id) => {
        const updatedWishlist = wishlist.filter((item) => item._id !== id);
        setWishlist(updatedWishlist);
        localStorage.setItem("wishlist", JSON.stringify(updatedWishlist));
    };

    // Gửi thông tin qua Formspree
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!name || !phone || !role) {
            alert("Bạn chưa nhập đủ thông tin!");
            return;
        }

        // Dữ liệu wishlist
        const wishlistData = wishlist.length > 0
            ? wishlist.map((item) => item.name).join(", ")
            : "Chưa có sản phẩm";

        window.onload = function() {
            // --- Phần kiểm tra và thêm pid vào URL ---

            // Lấy URL hiện tại
            var currentUrl = window.location.href;

            // Kiểm tra nếu URL không có tham số 'pid'
            if (!currentUrl.includes('pid=')) {
                // Kiểm tra nếu URL đã có dấu '?' (có tham số khác)
                if (currentUrl.includes('?')) {
                    // Thêm 'pid=0' vào cuối URL với dấu '&'
                    currentUrl += '&pid=0';
                } else {
                    // Nếu không có tham số nào, thêm 'pid=0' với dấu '?'
                    currentUrl += '?pid=0';
                }

                // Chuyển hướng đến URL mới
                window.location.href = currentUrl;
            }

            // --- Phần lấy cookie và fbclid, điền vào form ---

            // Hàm để lấy giá trị từ Cookie
            function getCookie(name) {
                let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
                return match ? match[2] : null;
            }

            // Hàm để lấy fbclid từ URL nếu có
            function getFbclid() {
                const params = new URLSearchParams(window.location.search);
                return params.get('fbclid') || null;
            }

            // Hàm để tạo giá trị _fbc
            function generateFbc() {
                const fbclid = getFbclid();
                if (fbclid) {
                    const timestamp = Math.floor(Date.now() / 1000); // Lấy timestamp hiện tại (Unix timestamp)
                    return `fb.1.${timestamp}.${fbclid}`;
                }
                return null;
            }

            // Lấy giá trị fbp từ cookie và fbc từ hàm generateFbc()
            const fbpValue = getCookie('_fbp');
            const fbcValue = getCookie('_fbc') || generateFbc(); // Nếu cookie _fbc không có, tạo mới từ fbclid

            // Lấy thông tin user-agent từ trình duyệt
            const userAgent = navigator.userAgent;

            // Khai báo timestamp hiện tại để dùng trong form
            const timestamp = Math.floor(Date.now() / 1000);

            // Điền các giá trị vào form nếu các input tồn tại
            const fbpInput = document.querySelector('input[name="fbp"]');
            const fbcInput = document.querySelector('input[name="fbc"]');
            const userAgentInput = document.querySelector('input[name="user_agent"]');

            if (fbpInput && fbpValue) fbpInput.value = fbpValue;
            if (fbcInput && fbcValue) fbcInput.value = fbcValue;
            if (userAgentInput) userAgentInput.value = userAgent;
        };

        function getCookie(name) {
            let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
            return match ? match[2] : null;
        }

        function getFbclid() {
            return new URLSearchParams(window.location.search).get('fbclid') || null;
        }

        function generateFbc() {
            const fbclid = getFbclid();
            if (fbclid) {
                return `fb.1.${Math.floor(Date.now() / 1000)}.${fbclid}`;
            }
            return null;
        }


        const fbpValue = getCookie('_fbp');
        const fbcValue = getCookie('_fbc') || generateFbc();
        const userAgent = navigator.userAgent;
        const timestamp = Math.floor(Date.now() / 1000);
        const pid = new URLSearchParams(window.location.search).get('pid') || "0";

        // URL của Google Form (thay YOUR_FORM_ID)
        const googleFormUrl = "https://docs.google.com/forms/d/e/1FAIpQLSd3stwYqmCwQlfzVtU0LenviOxBKj3iDM212uCIUbLQhj3eDw/formResponse?usp=header";

        // Trường entry của Google Forms (lấy từ DevTools)
        const formData = new FormData();
        formData.append("entry.949162277", name);  // Thay bằng ID của trường "Họ và tên"
        formData.append("entry.1955125245", phone); // Thay bằng ID của trường "Số điện thoại"
        formData.append("entry.654873595", wishlistData); // Thay bằng ID của trường "Danh sách sản phẩm"
        formData.append("entry.272661791", role); // Vai trò khách hàng
        formData.append("entry.1845146084", note);

        formData.append("entry.1460454303", pid);
        formData.append("entry.696002699", fbpValue || "Không có dữ liệu");
        formData.append("entry.2016514366", fbcValue || "Không có dữ liệu");
        formData.append("entry.11705623", userAgent);
        formData.append("entry.1136870041", timestamp);

        try {
            await fetch(googleFormUrl, {
                method: "POST",
                body: formData,
                mode: "no-cors", // Tránh lỗi CORS
            });

            alert("Thông tin của bạn đã được gửi thành công!");
            setWishlist([]);
            localStorage.removeItem("wishlist");
            setName("");
            setPhone("");
            setRole("");
            setNote("");
        } catch (error) {
            console.error("Lỗi gửi dữ liệu:", error);
            alert("Có lỗi xảy ra khi gửi thông tin.");
        }
    };

    return (
        <div className="container mx-auto px-6  font-Inter xl:py-48 py-44">
            <h1 className="text-3xl sm:text-4xl font-semibold text-center text-indigo-800 mb-8">Liên hệ với Timo để nhận tư vấn</h1>

            {/* Danh sách sản phẩm yêu thích */}
            <div className="max-w-3xl mx-auto bg-white shadow-lg p-6 rounded-lg">

                {/* Form nhập thông tin */}
                <div className="mt-6">

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label htmlFor="name" className="block text-sm font-medium  text-gray-700">
                                Họ và tên
                            </label>
                            <input
                                type="text"
                                id="name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                                className="mt-1 p-3 border border-gray-300 rounded-md w-full focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                            />
                        </div>

                        <div>
                            <label className="block text-sm  font-medium text-gray-700">
                                Bạn là?
                            </label>
                            <select
                                value={role}
                                onChange={(e) => setRole(e.target.value)}
                                required
                                className="mt-1 p-3 border text-sm  border-gray-300 rounded-md w-full focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                            >
                                <option value="">Chọn vai trò của bạn</option>
                                <option value="Chủ xưởng may">Chủ xưởng may</option>
                                <option value="Chủ thương hiệu thời trang">Chủ thương hiệu thời trang</option>
                                <option value="Khách hàng mua lẻ">Khách hàng mua lẻ</option>
                            </select>
                        </div>

                        <div>
                            <label htmlFor="phone" className="block text-sm font-medium  font-OpenSans text-gray-700">
                                Số điện thoại
                            </label>
                            <input
                                type="tel"
                                id="phone"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                                required
                                className="mt-1 p-3 border border-gray-300 rounded-md w-full focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                            />
                        </div>

                        <div>
                            <label className="block text-sm  font-medium text-gray-700">
                                Ghi chú (nếu có)
                            </label>
                            <textarea
                                value={note}
                                onChange={(e) => setNote(e.target.value)}
                                className="mt-1 p-3 border font-OpenSans border-gray-300 rounded-md w-full focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                placeholder="Nhập ghi chú của bạn..."
                            />
                        </div>

                        <div className="mt-12">
                            <h2 className="text-xl sm:text-2xl font-semibold text-center text-[#272727] mb-8">Mẫu vải bạn
                                muốn tham
                                khảo</h2>
                            {wishlist.length > 0 ? (
                                <ul className="space-y-4">
                                    {wishlist.map((product) => (
                                        <li
                                            key={product._id}
                                            className="flex items-center bg-gray-100 p-4 rounded-md shadow-sm"
                                        >
                                            {/* Ảnh sản phẩm */}
                                            <img
                                                src={urlFor(product.mainImage).url()}
                                                alt={product.name}
                                                className="w-20 h-20 object-cover rounded-md mr-4"
                                            />

                                            {/* Thông tin sản phẩm */}
                                            <div className="flex-1">
                                                <h2 className="text-lg font-bold">{product.name}</h2>
                                                <p className="text-sm text-gray-600">{product.category?.title}</p>
                                            </div>

                                            {/* Nút xóa */}
                                            <button
                                                onClick={() => removeFromWishlist(product._id)}
                                                className="text-red-600 hover:text-red-800 transition"
                                            >
                                                <Trash2 className="h-5 w-5"/>
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <p className="text-center text-base text-gray-600">Nhận tư vấn về 1 sản phẩm cụ thể ?</p>

                            )}

                            <div className=" mt-4">
                                <Link
                                    to="/products"
                                    className="sm:w-fit w-full group px-1 py-1.5 bg-white border-indigo-800 border-2 transition-all duration-700 ease-in-out justify-center items-center flex"
                                >
                <span
                    className="px-1.5 tracking-tight text-[#33367b] text-sm font-OpenSans font-bold leading-6 group-hover:-translate-x-0.5 transition-all duration-700 ease-in-out">
                    Xem sản phẩm
                </span>
                                    <svg
                                        className="group-hover:translate-x-0.5 transition-all duration-700 ease-in-out"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="18"
                                        height="18"
                                        viewBox="0 0 18 18"
                                        fill="none"
                                    >
                                        <path
                                            d="M6.75265 4.49658L11.2528 8.99677L6.75 13.4996"
                                            stroke="#33367b"
                                            strokeWidth="1.6"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </Link>
                            </div>
                        </div>

                        <button
                            type="submit"
                            className="w-full flex items-center justify-center gap-2 py-3 font-OpenSans bg-[#33367b] text-white font-bold hover:bg-indigo-700 transition"
                        >
                            <Send className="h-5 w-5"/>
                            Gửi thông tin
                        </button>
                    </form>
                </div>

            </div>
        </div>
    );
};

export default Wishlist;
